module.exports = __webpack_public_path__ + "static/img/division_1.b8f2cd3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/fortnite/division_1.svg
// module id = BpPq
// module chunks = 35